// extracted by mini-css-extract-plugin
export default {"thin":"thin--7899eeae","medium":"medium--f6a8e77d","thick":"thick--e777043c","spinner":"spinner--766f55d2"};